import { route } from "react-router-typesafe-routes/dom";

export const AUTH_ROUTES = {
  LOGIN: route("login"),
  AUTH_REDIRECT: route("auth-redirect"),
  SIGN_OUT: route("sign-out"),
  UNAUTHORIZED: route("401"),
};
